import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Address from "../components/Address/Address";
import Hall from "../components/Hall/Hall";
import Header from "../components/Header/Header";
import "../styles/main.css";
import Calendar from "../components/Calendar/Calendar";
import Time from "../components/Time/Time";
import Etc from "../components/Etc/Etc";
import Data from "../components/Data/Data";
import People from "../components/People/People";
import axios from "axios";
import { API_BASE_URL } from "../utils/config";
import { createDate, createDateTS, formatDate } from "../utils/utils";
import Confirm from "../components/Confirm/Confirm";
import { useNavigate } from "react-router";
import { useSnackbarAlert } from "../providers/SnackbarProvider";

function Booking() {
    const navigate = useNavigate();
    const snackbar = useSnackbarAlert();

    const [currentPage, setCurrentPage] = useState(1);
    const [direction, setDirection] = useState(1);
    const [hallsData, setHallsData] = useState(null);
    const [selectedHallData, setSelectedHallData] = useState(null);
    const [orders, setOrders] = useState(null);

    const [orderLoading, setOrderLoading] = useState(false);
    const [etcLoading, setEtcLoading] = useState(false);
    const [clientLoading, setClientLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitDisable, setSubmitDisable] = useState(false);
    const [etc, setEtc] = useState(null);
    const [client, setClient] = useState(null);
    const [slots, setSlots] = useState([]);
    const slotInterval = 30 * 60 * 1000;
    const bufferTimeMinutes = 30;
    const bufferTimeMs = bufferTimeMinutes * 60 * 1000;

    const [filial, setFilial] = useState(0);
    const [hall, setHall] = useState(0);
    const [date, setDate] = useState();
    const [durationMinutes, setDurationMinutes] = useState(120);
    const [startSlot, setStartSlot] = useState(null);
    const [sliderValue, setSliderValue] = useState(120);
    const [sliderTime, setSliderTime] = useState("");
    const [price, setPrice] = useState(0);
    const [priceList, setPriceList] = useState(null);
    const [kinoNight, setKinoNight] = useState(0);
    const [etcSmeta, setEtcSmeta] = useState({});
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("+7");
    const [email, setEmail] = useState("");
    const [people, setPeople] = useState(0);
    const [com, setCom] = useState("");
    const [checked1, setChecked1] = useState(false);
    const [checked2, setChecked2] = useState(false);

    const header = {
        1: {
            title: "Выберите адрес",
            text: "Наши кинозалы рассчитаны на компании до 8 человек и расположены по двум адресам.",
            step: 1
        },
        2: {
            title: "Выберите зал",
            text: selectedHallData?.AddressFull,
            step: 2
        },
        3: {
            title: "Сколько вас?",
            text: `${selectedHallData?.AddressFull}, зал №${hall}`,
            step: 3
        },
        4: {
            title: "Выберите дату и время",
            step: 4
        },
        5: {
            title: "Что-то еще?",
            text: "",
            step: 5
        },
        6: {
            title: "Ваши данные",
            text: "",
            step: 6
        },
        7: {
            title: "Оформление заказа",
            text: "",
            step: 7
        }
    }
    const [headerData, setHeaderData] = useState(header[1]);

    // Load halls data
    useEffect(() => {
        getHalls();

        async function getHalls() {
            try {
                const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                    type: 'getHalls'
                }, {
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    withCredentials: true
                });
                
                setHallsData(res?.data);
            } catch (err) {
                snackbar.error("Ошибка загрузки филиалов. Перезагрузите страницу или попробуйте позже.");
            }
        }
    }, []);

    // Reset time, orders
    useEffect(() => {
        setDurationMinutes(120);
        setStartSlot(null);
        setSliderValue(120);
        setSliderTime("");
        setOrders(null);
        setPrice(0);
        setPriceList(null);
        setKinoNight(0);
    }, [filial, hall, date]);

    useEffect(() => {
        if (currentPage === 4 && date) getOrders();
    }, [date, hall]);

    // Reset hall, people, date
    useEffect(() => {
        setHall(0);
        setPeople(0);
        setDate(null);
    }, [filial]);
    
    // Reset client
    useEffect(() => {
        setClient(null);
    }, [phone]);

    const changePage = (nextPage) => {
        if (nextPage === 5 && (etcLoading && etc === null)) return;
        if (nextPage === 7 && (clientLoading && client === null)) return;
        
        if (nextPage === 5 && !orderLoading && orders === null) {
            getOrders();
            return;
        } else if (nextPage === 5 && !etcLoading && etc === null) {
            getEtc();
            return;
        } else if (nextPage === 7 && !clientLoading && client === null) {
            getClient();
            return;
        }

        window.scrollTo(0, 0);
        setDirection(nextPage > currentPage ? 1 : -1);
        setCurrentPage(nextPage);
        setHeaderData(header[nextPage]);
    };

    async function getOrders() {
        const dateStr = new Date(date).toLocaleDateString("ru-RU");

        const dateStart = createDate(dateStr);
        dateStart.setDate(dateStart.getDate() - 2);
        const orderDateStart = Math.floor(dateStart.getTime() / 1000);

        const dateEnd = createDate(dateStr);
        dateEnd.setDate(dateEnd.getDate() + 2);
        const orderDateEnd = Math.floor(dateEnd.getTime() / 1000);
        
        setOrderLoading(true);
        setOrders(null);
        try {
            const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                type: 'getOrders',
                idOrder: null,
                filial: filial,
                hall: hall,
                dateStart: orderDateStart,
                dateEnd: orderDateEnd,
                
            }, {
                headers: {
                'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            
            // console.log(res.data)
            setOrders(res?.data);
            slotsRender(res?.data);
            
            // if (currentPage === 4) {
            //     window.scrollTo(0, 0);
            //     setDirection(1);
            //     setCurrentPage(5);
            //     setHeaderData(header[5]);
            // }
            
        } catch (err) {
            // console.log(err.response);
            snackbar.error("Ошибка загрузки заказов. Перезагрузите страницу или попробуйте позже.");
        } finally {
            setOrderLoading(false);
        }
    }

    async function getEtc() {
        setEtcLoading(true);
        try {
            const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                type: 'loadEtc',
                filial: filial
            }, {
                headers: {
                'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            
            // console.log(res.data);
            setEtc(res?.data);
            if (currentPage === 4) {
                window.scrollTo(0, 0);
                setDirection(1);
                setCurrentPage(5);
                setHeaderData(header[5]);
            }            
        } catch (err) {
            // console.log(err.response);
            snackbar.error("Ошибка загрузки услуг. Перезагрузите страницу или попробуйте позже.");
        } finally {
            setEtcLoading(false);
        }
    }

    async function getClient() {
        setClientLoading(true);
        setClient(null);
        try {
            const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                type: 'getClient',
                phone: phone.replace(/\D/g, '')
                
            }, {
                headers: {
                'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            
            // console.log(res?.data)
            setClient(res?.data);
            
            if (currentPage === 6) {
                window.scrollTo(0, 0);
                setDirection(1);
                setCurrentPage(7);
                setHeaderData(header[7]);
            }
            
        } catch (err) {
            // console.log(err.response);
            snackbar.error("Ошибка загрузки клиента. Перезагрузите страницу или попробуйте позже.");
        } finally {
            setClientLoading(false);
        }
    }

    function slotsRender(currentOrders) {
        const currentDateSlots = createDate(new Date(date).toLocaleDateString("ru-RU"));
        const newSlots = [];

        for (let i = 0; i < 66; i++) {
            const slotStart = currentDateSlots.getTime() + i * slotInterval;
            const slotEnd = slotStart + slotInterval;

            let isTaken = false;
            let isBuffered = false;

            currentOrders.forEach(order => {
                const bufferedStart = order.start - bufferTimeMs;
                const bufferedEnd = order.end + bufferTimeMs;

                if (!(slotEnd <= bufferedStart || slotStart >= bufferedEnd)) {
                    if (!(slotEnd <= order.start || slotStart >= order.end)) {
                        isTaken = true;
                    } else {
                        isBuffered = true;
                    }
                }
            });

            const isNextDay = new Date(slotStart).getDate() !== currentDateSlots.getDate();

            newSlots.push({
                start: slotStart,
                end: slotEnd,
                isTaken,
                isBuffered,
                isNextDay,
                timeString: new Date(slotStart).toLocaleTimeString('ru-RU', {
                    hour: '2-digit',
                    minute: '2-digit'
                })
            });
        }

        setSlots(newSlots);
    }

    async function submit() {
        setSubmitLoading(true);
        await new Promise(res => setTimeout(res, 1500));
        try {
            const res = await axios.post(`${API_BASE_URL}/api/index.php`, {
                type: 'saveOrder',
                fromOnline: true,
                idOrder: null,
                phone: phone.replace(/\D/g, ''),
                name: name,
                email: email,
                filial: filial,
                hall: hall,
                orderCom: com,
                countPeople: people,
                typeOrder: 1,
                startTime: Math.floor(startSlot / 1000),
                endTime: Math.floor((startSlot + durationMinutes * 60 * 1000) / 1000),
                etcSmeta: etcSmeta,
                kinoNight: kinoNight
            }, {
                headers: {
                'Content-Type': 'application/json'
                },
                withCredentials: true
            });
            
            // console.log(res.data)
            
            if(res?.data.status === "success") {
                setSubmitDisable(true);
                window.location.href = `/order/${res.data.link}`;
                // navigate(`/order/${res.data.link}`);
            }            
        } catch (err) {
            // console.log(err.response.data.error);
            snackbar.error(err.response.data?.error || "Ошибка создания брони. Перезагрузите страницу или попробуйте позже.");
        } finally {
            setSubmitLoading(false);
        }
    }

    const pages = {
        1: <Address
                hallsData={hallsData}
                setSelectedHallData={setSelectedHallData}
                filial={filial}
                setFilial={setFilial}
                changePage={changePage}
            />,
        2: <Hall
                selectedHallData={selectedHallData}
                hall={hall}
                setHall={setHall}
                filial={filial}
                changePage={changePage}
            />,
        3: <People
                maxPeople={(selectedHallData && hall) && JSON.parse(selectedHallData?.HallsData)[hall].maxPeople || 0}
                people={people}
                setPeople={setPeople}
                changePage={changePage}
            />,
        4: <Calendar
                date={date}
                setDate={setDate}
                orderLoading={orderLoading}
                startSlot={startSlot}
                setStartSlot={setStartSlot}
                durationMinutes={durationMinutes}
                setDurationMinutes={setDurationMinutes}
                sliderValue={sliderValue}
                setSliderValue={setSliderValue}
                sliderTime={sliderTime}
                setSliderTime={setSliderTime}
                orders={orders}
                slots={slots}
                setSlots={setSlots}
                price={price}
                setPrice={setPrice}
                setPriceList={setPriceList}
                kinoNight={kinoNight}
                setKinoNight={setKinoNight}
                slotInterval={slotInterval}
                bufferTimeMs={bufferTimeMs}
                people={people}
                filial={filial}
                hall={hall}
                etcLoading={etcLoading}
                changePage={changePage}
            />,
        5: <Etc
                etc={etc}
                etcSmeta={etcSmeta}
                setEtcSmeta={setEtcSmeta}
                changePage={changePage}
            />,
        6: <Data
                name={name}
                setName={setName}
                phone={phone}
                setPhone={setPhone}
                email={email}
                setEmail={setEmail}
                com={com}
                setCom={setCom}
                checked1={checked1}
                setChecked1={setChecked1}
                checked2={checked2}
                setChecked2={setChecked2}
                changePage={changePage}
            />,
        7: <Confirm
                name={name}
                phone={phone}
                email={email}
                com={com}
                client={client}
                startSlot={startSlot}
                durationMinutes={durationMinutes}
                selectedHallData={selectedHallData}
                hall={hall}
                people={people}
                priceList={priceList}
                kinoNight={kinoNight}
                etc={etc}
                etcSmeta={etcSmeta}
                submitLoading={submitLoading}
                submitDisable={submitDisable}
                changePage={changePage}
                submit={submit}
            />
    };

    const variants = {
        enter: (direction) => ({
            x: direction > 0 ? "100%" : "-100%",
            opacity: 0,
        }),
        center: {
            x: 0,
            opacity: 1,
        },
        exit: (direction) => ({
            x: direction > 0 ? "-100%" : "100%",
            opacity: 0,
        }),
    };

    return (
        <div className="background">
            <Header
                headerData={headerData}
                selectedHallData={selectedHallData}
                people={people}
                hall={hall}
                setHall={setHall}
            />

            <div style={{ position: "relative", minHeight: "500px" }}>
                <AnimatePresence mode="wait" custom={direction}>
                    <motion.div
                        key={currentPage}
                        custom={direction}
                        variants={variants}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{ duration: 0.5 }}
                        style={{ width: "100%" }}
                    >
                        {pages[currentPage]}
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    );
}

export default Booking;
